'use client'

import { useCatalogMedia } from '@/features/veluvit/hooks/use-app-data'
import { resolveChatSpeaker } from '@/features/veluvit/lib/chat-speaker'
import { workFor } from '@/features/veluvit/lib/rules'
import {
  roomIn,
  useSessionStore,
} from '@/features/veluvit/stores/session.store'

import type { SpeakerIdentity } from '@/features/veluvit/lib/chat-speaker'

/** 현재 방의 출연진 스냅샷을 우선한다. 메시지·지갑 변경에는 구독하지 않는다. */
export function useChatSpeaker(workId: string, identity: SpeakerIdentity = {}) {
  const { catalog, src, thumb } = useCatalogMedia()
  const snapshot = useSessionStore((state) => roomIn(state, workId)?.work)
  return resolveChatSpeaker(
    workId,
    snapshot ?? workFor(catalog, workId),
    identity,
    {
      name: catalog.chars[workId]?.short || catalog.chars[workId]?.name,
      image: thumb(workId),
      avatar: src(workId, 'avatar'),
    }
  )
}
